import React, { FC } from 'react'
import { Avatar, Button, HStack, Text, Wrap, WrapItem } from '@chakra-ui/react'
import ContactBrokerModal from '@/app/components/modals/ContactBrokerModal'
import { BrokerDTO } from '@/core/broker/typings'
import { ImageVariants } from '@/core/media/typings'
import { getDisplayImageUrl } from '@/core/media/utils/get-display-image-url'
import { RealEstateDTO, RealEstateLightDTO } from '@/core/real-estate/typings'

interface BrokersButtonsProps {
  brokers: BrokerDTO[]
  realEstate: RealEstateLightDTO | RealEstateDTO
}

const BrokersButtons: FC<BrokersButtonsProps> = ({ brokers, realEstate }) => {
  return (
    <Wrap w="full">
      {brokers.length
        ? brokers.map((b) => {
            const broker = b
            return (
              <WrapItem
                key={broker.id}
              >
                <ContactBrokerModal
                  trigger={
                    <Button
                      transitionDuration="0.25s"
                      _hover={{ transform: 'translateY(-1.5px)', shadow: 'md' }}
                      size="md"
                      rounded="full"
                      py={1}
                      px={1}
                      bg="background.surface">
                      <HStack as="span" w="full" h="full" spacing={0.5}>
                        <Avatar
                          src={getDisplayImageUrl(broker.img, ImageVariants['600x600'])}
                          h={9}
                          w={9}
                        />
                        <Text as="span" px={2} flex={1} fontSize="sm" fontWeight="medium">
                          {broker.name}
                        </Text>
                      </HStack>
                    </Button>
                  }
                  realEstate={realEstate}
                  broker={broker}
                />
              </WrapItem>
            )
          })
        : null}
    </Wrap>
  )
}

export default BrokersButtons
